// extracted by mini-css-extract-plugin
export default {"products":"Products_products__aHIsc","error":"Products_error__1S8td","noResults":"Products_noResults__Uyqo1","pagination":"Products_pagination__UKQxC","page":"Products_page__s93kv"};